import Axios from 'axios'
import { Component, ForwardedRef, forwardRef } from 'react'
import { MessageType, Sender, Language } from '../../globals'
import micIcon from '../../assets/mic.svg'
import recorder from '../../recorder/recorder'
import './recorder.style.scss'

function transcribe<T>(url: string, data: T, language: Language | null) {
  let xLanguage = 'sv'
  if (language?.locale?.length) {
    if (language?.locale.indexOf('_')) {
      xLanguage = language?.locale?.split('_')[0]
    } else if (language?.label.indexOf('-')) {
      xLanguage = language?.locale?.split('-')[0]
    }
  }

  let transcriptionUrl = url
  if (language?.transcriptionUrl?.length) {
    transcriptionUrl = language?.transcriptionUrl
  }

  return Axios.post(transcriptionUrl, data, {
    headers: {
      'Content-Type': 'audio/wave',
      'X-System-Prompt': language?.systemPrompt,
      'X-Language': xLanguage
    }
  })
}

type RecorderState = {
  isRecording: boolean
  responseReceived: number
  responseArray: object[]
}

type RecorderProps = {
  activeLanguage: Language | null
  talkToChat: (
    message: string,
    sender: Sender,
    type: MessageType,
    sendViaNetwork?: boolean
  ) => void
  setMessageSending: (isSending: boolean) => void
  transcriptionUrl: string
  isInbox?: boolean
}
class RecorderBase extends Component<
  RecorderProps & { forwardedRef: ForwardedRef<HTMLButtonElement> },
  RecorderState
> {
  state = {
    isRecording: false,
    responseReceived: 0,
    responseArray: [
      {
        locale: 'en_US',
        errorMessage: "Seems like I can't hear you. Please try again."
      },
      {
        locale: 'sv_SE',
        errorMessage:
          'Det verkar som att jag inte hör dig. Var god försök igen.'
      }
    ]
  }

  updateNumberOfSilence = async (numberOfSilence: number) => {
    if (numberOfSilence === 100 || numberOfSilence > 100) {
      await this.stop()
    }
  }

  start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      await recorder.init(stream, this.updateNumberOfSilence)
      recorder.start()
      this.setState({ isRecording: true })
    } catch (error) {
      console.error(error)
    }
  }

  stop = async () => {
    const {
      setMessageSending,
      transcriptionUrl,
      talkToChat,
      activeLanguage,
      isInbox
    } = this.props
    try {
      setMessageSending(true)
      this.setState({ isRecording: false })
      const blob = recorder.stop()
      const { data } = await transcribe(transcriptionUrl, blob, activeLanguage)
      if (data.length) {
        let textData = data.map((item: any) => item.word).join(' ')
        talkToChat(
          textData,
          isInbox == true ? Sender.AGENT : Sender.CUSTOMER,
          MessageType.TEXT
        )
      }
    } catch (error) {
      const { responseReceived, responseArray } = this.state
      if (responseReceived < 2) {
        this.setState({
          responseReceived: this.state.responseReceived + 1
        })
      }
      const localeString: string = activeLanguage
        ? activeLanguage.locale || 'en_US'
        : 'en_US'
      // console.log('localeString', localeString)
      talkToChat(
        responseArray.filter((rArray) => rArray.locale === localeString)[0]
          .errorMessage,
        isInbox == true ? Sender.AGENT : Sender.CUSTOMER,
        MessageType.TEXT
      )
      console.error(error)
    }
    setMessageSending(false)
  }

  render() {
    const {
      start,
      stop,
      state: { isRecording },
      props: { forwardedRef }
    } = this

    return (
      <button
        type="submit"
        className="btn btn-submit"
        onClick={isRecording ? stop : start}
        ref={forwardedRef}
      >
        {isRecording ? (
          <span id="inovia-recorder">
            <span />
          </span>
        ) : (
          <img src={micIcon} alt="record" className="micIcon" />
        )}
      </button>
    )
  }
}

export default forwardRef<HTMLButtonElement, RecorderProps>(function Recorder(
  props,
  ref
) {
  return <RecorderBase {...props} forwardedRef={ref} />
})
